import './Wote.css'

const Hero = () => {
  return (
    <section>
        <div className='bg-wote'>
        </div>
    </section>
  )
}

export default Hero